import { BreakoutTooltip } from 'components/design-system/BreakoutTooltip'
import { useTruncationDetection } from 'hooks/useTruncationDetection'
import { useRef } from 'react'
import classNames from 'classnames'

export const TruncatingText = ({
  text,
  className,
}: {
  text: string
  className?: string
}) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const { isTruncated } = useTruncationDetection({
    ref,
  })

  return (
    <BreakoutTooltip
      className="max-w-80"
      content={text}
      enabled={isTruncated}
      cloneRef={(clonedRef) => {
        ref.current = clonedRef as HTMLDivElement
      }}
    >
      <div ref={ref} className={classNames('truncate', className)}>
        {text}
      </div>
    </BreakoutTooltip>
  )
}
